import { render } from "./PageSpinner.vue?vue&type=template&id=281e31e2"
const script = {}

import "./PageSpinner.vue?vue&type=style&index=0&id=281e31e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__